import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import JobTitlesTable from "../Components/JobTitles/JobTitlesTable";
import JobTitlesDialogBox from "../Components/JobTitles/JobTitlesDialogBox";
import ProcessTable from "../Components/Process/ProcessTable";
import RegistrationTable from "../Components/Registrations/RegistrationTable";
import Scaffold from "../Components/Layout/Scaffold";
import { Button } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";

const Registrations = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function clearData() {
    setfilter({});
  }
  function clearSearch() {
    setTextInput("");
    setfilter({});
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Registrations"
      mainAction={null}
      actions={[
        <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxWidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                label="Search"
                variant="outlined"
                inputProps={{
                  style: {
                    width: "300px",
                    fontSize: "14px",
                  },
                }}
                size="small"
                placeholder="Enter search keyword"
                value={textInput}
                onEmptied={clearSearch}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>,
          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
      ]}
    >
      <>
        <RegistrationTable filter={filter} />
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </>
    </Scaffold>
  )


  // old code is below
  return (
    <>
      <p className="text-2xl mb-3 ">Registrations</p>
      {/* <div className="flex flex-col md:flex-row h-10">
        <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                width: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                inputProps={{
                  style: {
                    height: "3px",
                    fontSize: "14px",
                  },
                }}
                placeholder="Search"
                value={textInput}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>
          {textInput != "" ? (
            <button onClick={clearSearch}>
              <CancelIcon />
            </button>
          ) : (
            <></>
          )}
          <div>
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded ml-4 text-sm mt-1"
              onClick={() => {
                changeFilters("keyword", "" + textInput);
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div> */}
      {/* {!hide ? (
        <div>
          <div className="flex w-full mt-4">
            <div className="flex">
              <div>
                <FormControl size="small" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label">
                    Type
                  </InputLabel>
                  <Select
                    style={{
                      width: 150,
                      height: 30,
                      fontSize: 14,
                      marginTop: 5,
                    }}
                    size="small"
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={filter["status"]}
                    onChange={(event) => {
                      changeFilters("type[eq]", event.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"dom"}>Domestic</MenuItem>
                    <MenuItem value={"corp"}>Corporate</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3">
              <button
                className="flex bg-blue-800 hover:bg-blue-500 text-white font-bold py-1 pr-4 pl-2 rounded-lg ml-4 text-sm"
                onClick={() => {
                  changeFilters("timestamp", "" + Date.now());
                }}
              >
                <p className="text-sm ml-1">Search</p>
              </button>
            </div>
            <div
              className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3"
              onClick={clearData}
            >
              <button>
                <CancelIcon className="mt-1" fontSize="small" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )} */}
      <div>
        <RegistrationTable filter={filter} />
      </div>
      <div>
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </>
  );
};

export default Registrations;
